import constants from './constants';

const {
  NAMESPACE,
} = constants;

const DELETE_GROUP = `${NAMESPACE}/DELETE_GROUP` as const;

const FETCH_GROUP = `${NAMESPACE}/FETCH_GROUP` as const;

const FETCH_GROUPS = `${NAMESPACE}/FETCH_GROUPS` as const;

const SET_CURRENT_GROUP = `${NAMESPACE}/SET_CURRENT_GROUP` as const;

export default {
  DELETE_GROUP,
  FETCH_GROUP,
  FETCH_GROUPS,
  SET_CURRENT_GROUP,
};
